export default {
      id: "entitlement_system_default_image-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#entitlement_system_default_image",
      toString: function () {
        return this.url;
      }
    }